/* tslint:disable */
/* eslint-disable */
export enum WorkAbschlussrechnungStatusEnum {
  NotExists = 'NOT_EXISTS',
  Done = 'DONE',
  Open = 'OPEN'
}
